import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackEventListParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/trackEventList";

/* ---------------------------------------------------------------------------------------------------- */
// Toolkit Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackQuoteDeletedItem extends Toolkit.GoogleAnalytics.AnyProductItem {}

export interface TrackQuoteDeletedParameters
    extends TrackEventListParameters<"has_notes" | "type", null, TrackQuoteDeletedItem> {}

const trackQuoteDeleted = (parameters: TrackQuoteDeletedParameters, options?: Toolkit.GoogleAnalytics.Options) => {
    return ga.track.eventList({ action: "quote_deleted", ...parameters }, options);
};

export default trackQuoteDeleted;
